var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limit-box"},[_c('div',{staticClass:"tree-box treeScrollBar"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.treeData,"show-checkbox":"","default-expand-all":"","node-key":"id","props":_vm.defaultProps}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }